"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _TypeaheadRow = _interopRequireDefault(require("./TypeaheadRow"));

var _Constant = require("../../../Constant");

var _theme;

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-top: none;\n  min-width: 100%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 800;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var borderColor = (0, _styledTheming.default)('mode', (_theme = {
  caliber: _Constant.Color.CALIBER_BLUE_NEW
}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, _Constant.Color.BLACK), (0, _defineProperty2.default)(_theme, "homepoint", _Constant.Color.HOMEPOINT_NAVY), (0, _defineProperty2.default)(_theme, "figure", _Constant.Color.PURPLE_RAIN), (0, _defineProperty2.default)(_theme, "pella", _Constant.Color.PURPLE_RAIN), (0, _defineProperty2.default)(_theme, "petersendean", _Constant.Color.PURPLE_RAIN), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY), _theme));

var Wrapper = _styledComponents.default.div(_templateObject(), _Constant.Color.WHITE, borderColor);

var Typeahead = function Typeahead(_ref) {
  var handleSelect = _ref.handleSelect,
      renderRow = _ref.renderRow,
      highlightedIndex = _ref.highlightedIndex,
      results = _ref.results,
      labelledBy = _ref.labelledBy,
      id = _ref.id,
      fsMask = _ref.fsMask;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    role: "listbox",
    "aria-labelledby": labelledBy,
    id: id,
    className: fsMask ? 'fs-mask' : ''
  }, results.map(function (obj, index) {
    return /*#__PURE__*/_react.default.createElement(_TypeaheadRow.default, {
      key: Object.values(obj).reduce(function (prev, curr) {
        return "".concat(prev, ",").concat(curr);
      }, ''),
      id: "".concat(id, "-option-").concat(index),
      handleClick: function handleClick() {
        handleSelect(obj);
      },
      ariaSelected: highlightedIndex === index
    }, renderRow(obj));
  }));
};

Typeahead.propTypes = {
  /** The input's aria-controls attribute uses this id to identify the popup element */
  id: _propTypes.default.string.isRequired,
  handleSelect: _propTypes.default.func.isRequired,

  /** Matches the index of the currently highlighted option for keyboard and assistive technology users. Used to assign a value to the aria-selected attribute. */
  highlightedIndex: _propTypes.default.number,

  /** aria-labelledby gives the popup element an accessible name that matches the visible label. */
  labelledBy: _propTypes.default.string.isRequired,
  renderRow: _propTypes.default.func.isRequired,
  results: _propTypes.default.array.isRequired,
  fsMask: _propTypes.default.bool.isRequired
};
Typeahead.defaultProps = {
  highlightedIndex: null
};
var _default = Typeahead;
exports.default = _default;